import React, { Component } from "react";
import { Col, Alert, Row } from "react-bootstrap";
import EventMap from "src/component/SafetyMap/EventMap";
import EventGraph from "src/component/SafetyMap/EventGraph";
import "openlayers/css/ol.css";
import { msgs } from "src/js/ErrorMessage.js";
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class EventDetail extends Component {
  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        <Alert bsStyle="danger">
          <p>{t("Message." + msgs["msg_common_01"])}</p>
        </Alert>
      </div>
    );

    const StatMapSetRow = () => (
      <div>
        <Row>
          <Col md={12} sm={12} xs={12}>
            <EventMap
              safetyMapData={this.props.safetyMapData}
              safetyMapLoading={this.props.safetyMapLoading}
              isAccidentData={this.props.isAccidentData}
              accidentDataList={this.props.accidentDataList}
              logCarId={this.props.logCarId}
              eventPeriodFrom={this.props.eventPeriodFrom}
              eventPeriodTo={this.props.eventPeriodTo}
            />
          </Col>
        </Row>
        <div className="mini-div" />
        <Row>
          <Col md={12} sm={12} xs={12}>
            <EventGraph
              data={this.props.safetyMapData}
              safetyMapLoading={this.props.safetyMapLoading}
              isSafetyMap={this.props.isSafetyMap}
              eventPeriodFrom={this.props.eventPeriodFrom}
              eventPeriodTo={this.props.eventPeriodTo}
            />
          </Col>
        </Row>
      </div>
    );

    // 表示させるトリップ詳細が無い場合
    if (!this.props.isSafetyMap) {
      return (
        <Col md={12} sm={12} xs={12}>
          <Error />
        </Col>
      );
    }

    return (
      <StatMapSetRow />
    );
  }
}

export default withTranslation()(EventDetail);



// WEBPACK FOOTER //
// ./src/component/SafetyMap/EventDetail.js